/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Status_StartingInputs */

const vi_irrigation_run_status_starting = /** @type {(inputs: Irrigation_Run_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang bật`)
};

/**

* @param {Irrigation_Run_Status_StartingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_status_starting = /** @type {((inputs?: Irrigation_Run_Status_StartingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Status_StartingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_status_starting(inputs)
});